import { isRenderableContinuation } from './post_approval_plaid';

export const isAmbiguousSkipError = (error) =>
  error.network ||
  error.reason_code === 'invalid_response' ||
  error.http_status >= 500;

export const baselineCreditLimit = ({ attempt, company }) => {
  const baselineCents = attempt.getIn([
    'baseline',
    'approved_credit_limit',
    'cents',
  ]);

  if (Number.isSafeInteger(baselineCents)) return baselineCents / 100;

  const companyCreditLimit = company?.credit_line?.get('amount');
  return Number.isFinite(companyCreditLimit) ? companyCreditLimit : null;
};

export const continuationTarget = ({ attempt }) => {
  if (attempt.status !== 'skipped' || attempt.can_continue !== true) return null;

  return isRenderableContinuation(attempt.next_route_path)
    ? { kind: 'path', path: attempt.next_route_path }
    : { kind: 'route' };
};

export const skipEventProperties = ({ session, attempt, result }) => ({
  sessionType: session.session_type,
  hasShoppingCart: session.hasShoppingCart(),
  attemptStatus: attempt.status,
  result,
});
